import React from 'react';

import TruncatedCardText from './TruncatedCardText';

interface ProductDescriptionProps {
  description?: string | null;
  isSelected?: boolean;
  maxChars?: number;
}

const ProductDescription: React.FC<ProductDescriptionProps> = ({ description, isSelected = false, maxChars = 70 }) => {
  return (
    <TruncatedCardText string={description} typographyVariant="caption" isSelected={isSelected} maxChars={maxChars} />
  );
};

export default ProductDescription;
